export default __webpack_public_path__ + "static/media/Group38285.f676ab38.png";